import React from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "../../../actions/actionCreators";
import MaterialModal from "../MaterialModal";
import Button from "@material-ui/core/Button";
import withModal from "../withModal";

interface IInsightsInvalidLink {
    isOpen: boolean;
    modalProps: {
        nodeType: string;
        hasThirdParty: boolean;
        supportEmailAddress: string;
    };
}

const InsightsInvalidLink: React.FC<IInsightsInvalidLink> = ({ isOpen, modalProps }: IInsightsInvalidLink) => {
    const dispatch = useDispatch();

    const hide = () => dispatch(hideModal("INSIGHTS_INVALID_LINK"));
    let nodeName = "Unknown Node";
    switch (modalProps.nodeType) {
        case "insights":
            nodeName = "Basic Insights";
            break;
        case "discovery":
            nodeName = "Audience Insights";
            break;
    }

    const emailLink = <a href={`mailto:${modalProps.supportEmailAddress}`}>{modalProps.supportEmailAddress}</a>;

    const customFooter = (
        <Button variant="contained" color="primary" onClick={hide} style={{ margin: "3px" }}>
            OK
        </Button>
    );

    // Content for the modal based on whether it has third-party OR OAC data
    const modalContent = modalProps.hasThirdParty ? (
        <div>
            <span style={{ fontSize: "18px" }}>
                We cannot use your Partner Audiences in Audience Engine&apos;s Marketplace in <b>{nodeName}</b>.
                <br />
                Please remove Partner Audiences in Audience Engine&apos;s Marketplace from your selections to use{" "}
                <b>{nodeName}</b>.
                <br />
                <br />
                Please reach out to {emailLink} if you have any questions.
            </span>
        </div>
    ) : (
        <div>
            <span style={{ fontSize: "18px" }}>
                OAC data cannot be pulled into in <b>{nodeName}</b>.
                <br />
                Please update your audience selections.
            </span>
        </div>
    );

    return (
        <MaterialModal
            title="Insights Link Not Allowed"
            isOpen={isOpen}
            onClose={() => hide()}
            id="insights-thirdparty"
            maxWidth="lg"
            showPrimaryButton={false}
            footer={customFooter}
            disableEscape={true}
        >
            {modalContent}
        </MaterialModal>
    );
};

export default withModal(InsightsInvalidLink, "INSIGHTS_INVALID_LINK");
